/* eslint-disable max-len */
export const track = (key) => {
  if (typeof window !== 'undefined' && window.LIFE_CYCLE_EVENT_BUS) {
    window.top.LIFE_CYCLE_EVENT_BUS.trigger(`fit-compatibility-drawer.${key}`);
  }
};

const validator = (str, validation) => {
  if (!str) return false;

  const lowerStr = str.toLowerCase();

  if (validation === 'washer' && lowerStr.includes('dishwasher')) {
    return false;
  }

  return lowerStr.includes(validation);
};

export const getApplianceType = (data) => {
  const {
    taxonomy = {},
    metadata = {},
    identifiers = {}
  } = data?.searchModel || data?.product || {};
  const { breadCrumbs = [] } = taxonomy;
  const {
    canonicalUrl = '',
    clearAllRefinementsURL = '',
    h1Tag = '',
  } = metadata;
  const {
    productLabel = ''
  } = identifiers;

  const applianceTypes = [
    { keywords: ['refrigerator', 'fridge'], type: 'REFRIGERATOR' },
    { keywords: ['laundry', 'washer', 'dryer', 'all-in-one'], type: 'LAUNDRY' },
    { keywords: ['range'], type: 'RANGE' }
  ];

  const matchedType = applianceTypes.find(({ keywords }) => keywords.some((validation) => (breadCrumbs && breadCrumbs.some(({ label }) => validator(label, validation)))
        || validator(canonicalUrl, validation)
        || validator(clearAllRefinementsURL, validation)
        || validator(h1Tag, validation)
        || validator(productLabel, validation)
  )
  );

  if (matchedType) {
    return matchedType.type;
  }

  return null;
};

export const isBuiltInAppliance = (data) => {
  const product = data?.product;
  if (!product?.specificationGroup) return false;

  return product.specificationGroup.some((group) => group?.specifications?.some(
    (spec) => {
      return (
        spec?.specName?.toLowerCase() === 'installation type'
        && spec?.specValue?.toLowerCase() === 'built-in'
      );
    }
  )
  );
};